import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './components/LoginPage';
import Dashboard from './components/Dashboard';

// ################################################ 
// COMPONENTS BÀSICS (Només per visualització de mentres pruebas)
// ################################################ 
const NoTrobat = () => <h1>404 - Pàgina no trobada</h1>;

// ################################################ 
// FUNCIÓ D'AUTENTICACIÓ 
// ################################################ 

// La funció comprova si l'usuari té un token d'accés a la memòria de sessió.
const estaAutenticat = () => {
  // Retorna TRUE si hi ha un token a l'emmagatzematge de SESSIÓ.
  return sessionStorage.getItem('token') !== null;
};

// Funció que gestiona l'accés a les rutes privades
const RutaPrivada = ({ children }) => {
  // Si l'usuari no està autenticat, el sistema el redirigeix a /login
  if (!estaAutenticat()) {
    return <Navigate to="/login" replace />;
  }
  // Si està autenticat, es mostra la pagina per exemple el dashboard
  return children;
};


function App() {
  return (
    <Router>
      <div className="App">
        <Routes>
          {/* Ruta de Login (Pública) */}
          <Route path="/login" element={<LoginPage />} />

          {/* Rutes protegides amb el RutaPrivada */}
          <Route path="/dashboard" element={
            <RutaPrivada>
              <Dashboard />
            </RutaPrivada>
          } />

          {/* Ruta de base on va tot el trafic inicial per defecte*/}
          <Route path="/" element={
            estaAutenticat() ? <Navigate to="/dashboard" replace /> : <Navigate to="/login" replace />
          } />

          {/* Ruta 404 per a qualsevol altre URL */}
          <Route path="*" element={<NoTrobat />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;